import { shouldSkipQuestionValidation } from './utils'

export function isAnswered(question, userAnswer) {
  if (shouldSkipQuestionValidation(question)) {
    return true
  }
  if (question.isAnswered) {
    return question.isAnswered(userAnswer)
  }
  if (userAnswer == null) {
    return false;
  }
  const { type, attrs, schema } = question
  const isMultipleType = ['multipleOptions', 'order'].includes(type);
  if (isMultipleType) {
    const max = attrs?.max || null;
    const length = attrs?.length || null;
    const userLength = userAnswer?.length || null;
    if (userAnswer && !userLength) {
      return false;
    }
    return (!length || length === userLength) && (!max || userLength <= max);
  }
  if (type === 'test') {
    // eslint-disable-next-line no-use-before-define
    return validate(schema?.questions, userAnswer);
  }
  return true;
}
// returns isValid
export default function validate(questions, answers) {
  if (!questions?.some) {
    return true;
  }
  return !questions.some((question) => !isAnswered(question, answers[question.id]));
}
